module.exports = __webpack_public_path__ + "img/__icon_BUS.92b4da18.svg";